<template>
  <div v-if="title" class="mb-16 flex flex-col md:items-baseline">
    <h2
      class="text-static-default-hi heading-2"
      :class="{ 'mb-8 md:mb-0 md:mr-12': subtitle }"
    >
      {{ title }}
    </h2>
    <span class="text-static-default-low body-1">
      {{ subtitle }}
    </span>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ title?: string; subtitle?: string | null }>(), {
  title: '',
  subtitle: '',
})
</script>
